import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserService } from '@pingum/api-services';
import {
  Tabs,
  Tab,
} from '@material-ui/core';

import Page from '../../widgets/Page';
import SettingsCard from './SettingsCard';
import UsersCard from './UsersCard';
import UsersRequestsCard from './UserRequestsCard';
import {
  getTenantFromUrl,
  getQueryParam,
  setQueryParam,
} from '../../../utils/urlHelper';
import {
  isUserAdmin,
  isUserOwner,
} from '../../../utils/tenantAuthenticationHelper';

const SETTINGS_VIEW = 'settings';
const USERS_VIEW = 'users';
const REQUETS_VIEW = 'requests';

const getTabContent = (tab, tenantName, isOwner) => {
  switch (tab) {
    case USERS_VIEW:
      return <UsersCard tenantName={tenantName} />;
    case REQUETS_VIEW:
      return <UsersRequestsCard tenantName={tenantName} />;
    case SETTINGS_VIEW:
    default:
      return isOwner
        ? <SettingsCard />
        : <UsersCard tenantName={tenantName} />;
  }
};

export const TenantSettingsComponent = () => {
  // redux state
  const { user: profile } = useSelector((state) => state.user);
  const { isFetchingTenant: isFetching } = useSelector((state) => state.tenant);

  // get roles for user
  const roles = UserService.getUserRolesForTenant(
    profile,
    getTenantFromUrl(),
  );
  const userIsOwner = isUserOwner(roles);
  const userIsAdmin = isUserAdmin(roles);

  // local state
  const [tenantName] = useState(getTenantFromUrl());
  const defaultView = (userIsOwner
    ? SETTINGS_VIEW
    : USERS_VIEW);
  const [selectedView, setSelectedView]
    = useState(getQueryParam('view')
      ? getQueryParam('view', 10)
      : defaultView);

  // set query param for selected view
  setQueryParam('view', selectedView);

  const handleChangeTab = (event, value) => {
    setSelectedView(value);
    setQueryParam('view', value);
  };

  return (
    <Page
      title="Organization"
      disableToolbarPadding
      showLoadingIndicator={isFetching}
      toolbar={!isFetching
      && (
        <Tabs
          value={selectedView}
          onChange={handleChangeTab}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="on"
        >
          {
          userIsOwner
          && (
            <Tab
              label="Settings"
              value={SETTINGS_VIEW}
            />
          )
        }
          {
          userIsAdmin
          && (
            <Tab
              label="Users"
              value={USERS_VIEW}
              data-testid="users-tab"
            />
          )
        }
          {
          userIsAdmin
          && (
            <Tab
              label="Requests To Join"
              value={REQUETS_VIEW}
              data-testid="requests-tab"
            />
          )
        }
        </Tabs>
      )}
    >
      {getTabContent(selectedView, tenantName, userIsOwner)}
    </Page>
  );
};

TenantSettingsComponent.propTypes = { };
TenantSettingsComponent.defaultProps = { };

export default TenantSettingsComponent;
